import React from "react";
import Calendar from "./CalenderStep";
import CheckoutStep from "./CheckoutStep";
import ProfessionalPerServices from "./ProfessionalPerService";
import ProfessionalStep from "./ProfessionalStep";
import ServicesStep from "./ServicesStep";

const DrawerSteps = ({
  activeStep,
  setIsLoading,
  handleCreateTeamData,
  allTeamMembers,
  selectedIds,
  selectedServices,
  handleSelectTeam,
  selectedTeam,
  handleSelectedDateTime,
  handleCreateAppointment,
  selectedTime,
  selectedDate,
}) => {
  switch (activeStep) {
    case 0:
      return (
        <ServicesStep
          selectedIds={selectedIds}
          setIsLoading={setIsLoading}
          selectedServices={selectedServices}
          handleCreateTeamData={handleCreateTeamData}
        />
      );
    case 1:
      return (
        <ProfessionalStep
          selectedTeam={selectedTeam}
          allTeamMembers={allTeamMembers}
          selectedServices={selectedServices}
          handleSelectTeam={handleSelectTeam}
        />
      );
    case 2:
      return (
        <ProfessionalPerServices
          selectedTeam={selectedTeam}
          selectedIds={selectedIds}
          setIsLoading={setIsLoading}
          handleSelectTeam={handleSelectTeam}
        />
      );
    case 3:
      return (
        <Calendar
          selectedTeam={selectedTeam}
          setIsLoading={setIsLoading}
          selectedTime={selectedTime}
          selectedDate={selectedDate}
          handleSelectedDateTime={handleSelectedDateTime}
        />
      );
    case 4:
      return (
        <CheckoutStep
          selectedTeam={selectedTeam}
          selectedServices={selectedServices}
          selectedTime={selectedTime}
          setIsLoading={setIsLoading}
          selectedDate={selectedDate}
          handleCreateAppointment={handleCreateAppointment}
        />
      );
    default:
      return (
        <ServicesStep
          selectedIds={selectedIds}
          setIsLoading={setIsLoading}
          selectedServices={selectedServices}
          handleCreateTeamData={handleCreateTeamData}
        />
      );
  }
};

export default DrawerSteps;
